import { render, staticRenderFns } from "./AssignToMeConfirmationDialog.vue?vue&type=template&id=76407628"
import script from "./AssignToMeConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./AssignToMeConfirmationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports